<template>
  <b-container style="padding: 5px; margin-bottom: 1.2rem;">
    <b-row v-for="i in config.rows" :key="i">
      <b-col style='padding: 1px; margin: auto' v-for="j in config.cols" :key="j">
        <div v-if="colors[((i-1)*config.cols) + (j-1)]">
          <p style='fontSize: 1rem; margin: auto;'>{{ colors[((i-1)*config.cols) + (j-1)].title + ': ' }}</p>
          <div v-bind:style='{ background: colors[((i-1)*config.cols) + (j-1)].color, width, height, margin }'> </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'colorpalette',
  props: ['colors', 'config'],
  data () {
    return {
      width: '25px',
      height: '25px',
      margin: 'auto'
    }
  }
}
</script>
